import { render, staticRenderFns } from "./mobile_container_depot_detail.vue?vue&type=template&id=1d1479f2&scoped=true&"
import script from "./mobile_container_depot_detail.vue?vue&type=script&lang=js&"
export * from "./mobile_container_depot_detail.vue?vue&type=script&lang=js&"
import style0 from "./mobile_container_depot_detail.vue?vue&type=style&index=0&id=1d1479f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1479f2",
  null
  
)

export default component.exports